"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = __importDefault(require("./base"));
var baseRequest = function (method, url, data, notice, id, addition) {
    return base_1.default(id ? url + "/" + id : url, __assign({ method: method, data: method === 'GET' ? undefined : data, params: method === 'GET' ? data : undefined, notice: notice }, addition));
};
var get = function () {
    var r = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        r[_i] = arguments[_i];
    }
    return baseRequest.apply(void 0, __spreadArray(['GET'], __read(r)));
};
var post = function () {
    var r = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        r[_i] = arguments[_i];
    }
    return baseRequest.apply(void 0, __spreadArray(['POST'], __read(r)));
};
var put = function () {
    var r = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        r[_i] = arguments[_i];
    }
    return baseRequest.apply(void 0, __spreadArray(['PUT'], __read(r)));
};
var patch = function () {
    var r = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        r[_i] = arguments[_i];
    }
    return baseRequest.apply(void 0, __spreadArray(['PATCH'], __read(r)));
};
var del = function () {
    var r = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        r[_i] = arguments[_i];
    }
    return baseRequest.apply(void 0, __spreadArray(['DELETE'], __read(r)));
};
exports.default = {
    base: base_1.default,
    read: get,
    post: post,
    put: put,
    patch: patch,
    del: del,
};
